import { Component, ElementRef, OnInit, inject } from '@angular/core';
import {
    MatSnackBarRef,
    MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    templateUrl: './cookies-snackbar.component.html',
    styleUrls: ['./cookies-snackbar.component.scss'],
    host: {
        class: 'cookie-wrapper',
    },
    imports: [
        MatIcon,
        MatAnchor,
        MatButton,
        TranslateModule,
    ]
})
export class CookiesSnackbarComponent implements OnInit {
    private snackRef = inject<MatSnackBarRef<CookiesSnackbarComponent>>(MatSnackBarRef);
    data = inject(MAT_SNACK_BAR_DATA);
    private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);


    ngOnInit(): void {
        // specific class to add high z-index to display this snackbar overlay over other overlays
        const overlay = this.elementRef.nativeElement.closest('div.cdk-global-overlay-wrapper');
        overlay?.classList.add('esp-cookies-overlay');
     }

    onAccept() {
        this.snackRef.dismissWithAction();
    }
}
